import {
    TOOGLE_SHOP_INTERESTED_MODAL
} from "../constants/action-types";

export function toogleInterestedModal(payload) {
    return { type: TOOGLE_SHOP_INTERESTED_MODAL, payload }
};
